export const NEW_PRO_DAYS = 30;
export const NEW_PRO_MIN_REVIEWS = 1;
